<div class="row justify-content-center">

  <!-- FORMULARIO -->
    <div class="col-md-10 col-lg-8 px-0 mb-3">
        <button class="btn btn-danger btn waves-effect btn-rounded pull-left m-r-5" (click)="back()">Atrás</button>

        <button style="margin-left: auto;" class="btn btn-success waves-effect btn btn-rounded m-r-5 f-right" (click)="generatePdf()"> Exportar a PDF</button>
        <button class="btn btn-primary waves-effect btn btn-rounded m-r-5 f-right" (click)="share()" > Compartir reporte</button>
    </div>

      <div *ngIf="selectedTest && form" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>{{form.title }}</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Respuestas acertadas: </b></strong><b class="text-gray f-bold">{{selectedTest.formScore}}/{{form.questions.length}}</b></p>
                </div>

                
            </div>

        </div>


        <div *ngIf="form" id="contentToExport4" #contentToExport4 >
        
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <ng-container *ngFor="let question of form.questions; index as i">

                <div *ngIf="getOptionClass(i, selectedTest.answers[i]) == 'wrong' || question.type == 'text'" class="question-container mb-3">
                    <h4><b>#{{i + 1}}</b></h4>
    
                    <h5><b>Descripción</b></h5>
                    <div [innerHTML]=" question.instructions | quillToHtml" ></div>
    
                    <h5 class="mt-3"><b>Pregunta</b></h5>
                    <div [innerHTML]=" question.question | quillToHtml" ></div>
                    <div class="row jcc mt-3">
                        <img class="question-img" *ngIf="question.questionImage" [src]="question.questionImage" alt="">
                    </div>
                    <h5 *ngIf="question.type != 'conditional'" class="mt-3"><b>Respuesta del usuario: <span [ngClass]="getOptionClass(i, selectedTest.answers[i])">{{getAnswerString(selectedTest.answers[i])}}</span></b></h5>
                    <h5 *ngIf="question.type == 'conditional'" class="mt-3"><b>Respuesta del usuario: <span >{{getAnswerString(selectedTest.answers[i])}}</span></b></h5>
                    
                    <ng-container *ngIf="question.type != 'conditional'">
                        <div *ngFor="let option of question.answers; index as j" class="col-12 answer-card mb-3" [ngClass]="option.correct ? 'correct' : ''">
                            <span>{{option.title}}</span>
                        </div>
                    </ng-container>
                    <div [innerHTML]=" question.explanation | quillToHtml" ></div>
    
                    <div class="row jcc mt-3 mb-5">
                        <img class="question-img" *ngIf="question.answerImage" [src]="question.answerImage" alt="">
                    </div>
    
    
                </div>
            </ng-container>

        </div>

        

        
    </div>

</div>